import { FC, ReactNode } from 'react';
import { Pie, PieChart, ResponsiveContainer } from 'recharts';

export interface IDonutChartData {
  name?: string,
  value: number,
  fill?: string,
  fillContrast?: string,
}

const DonutChart: FC<{
  data: IDonutChartData[],
  radius?: number,
  thin?: number,
  title?: ReactNode,
  prefix?: ReactNode,
  autoPrefix?: boolean,
  fill?: string,
}> = ({
  data,
  radius = 90,
  thin = 20,
  title = '',
  prefix = '',
  autoPrefix = false,
  fill = 'black',
}) => (
    <div className=" relative">
      <ResponsiveContainer
        height={200}
        width="100%"
      >      
        <PieChart
          height={200}
          width={200}
        >
          <Pie 
            data={data}
            // activeShape={() => {}}
            innerRadius={radius - thin}
            outerRadius={radius}
          />          
        </PieChart>
      </ResponsiveContainer>

      <div className="flex flex-col justify-center gap-1 items-center absolute top-0 right-0 bottom-0 left-0">
        {!!autoPrefix && (
          <div className="flex gap-1 items-end">
            {
              (data || [])
                .filter(({ value }) => value)
                .reduce((acc, { name, fill, value, fillContrast }, indx) => [
                    ...acc,
                    <div
                      key={`${title}-${fill}-${indx}-section`}
                      className="flex items-center text-[1em] py-1 px-[.4em] bg-opacity-30  leading-none rounded-lg"
                      style={{ 
                        background: fill,
                        color: fillContrast || 'white'
                      }}
                    >
                      {name || value}
                    </div>,
                    <div
                      key={`${title}-${fill}-${indx}-separator`}
                      className="text-gray-400 text-[.7em] pb-[.3em]"
                    > </div>
                  ], [] as ReactNode[])
                .slice(0, -1)
            }
          </div>
        )}
        {!!prefix && prefix}
        {!!title && title}
      </div>
    </div>
  );

export default DonutChart;
